<template>
    <div id="setUserPay">
        <!--头部导航栏-->
        <nav-bar>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
            </div>
            <div slot="title">支付密码设置</div>
        </nav-bar>
        <div style="height: 75px; width: 100%;"></div>

        <div style="width: 95%; margin: auto;">
        <van-form @submit="onSubmit">
                <van-field style="border-top-left-radius: 10px; border-top-right-radius: 10px;"
                        v-model="loginFrom.telephone"
                        name="手机号码"
                        label="手机号码"
                        placeholder="手机号码"
                />

                <van-field
                        v-model="loginFrom.authCode"
                        type="code"
                        name="短信验证码"
                        label="短信验证码"
                        placeholder=""
                        :rules="[{ required: true, message: '请填写手机短信验证码' }]"
                >
                <van-button slot="button" native-type="button" size="small" type="primary" @click="getcode" :disabled="disabled" >
                    发送验证码
                    <span v-if="this.num != 60 ">
                        ({{num}})
                    </span>
                </van-button>
               </van-field>


                <van-field
                        v-model="loginFrom.password"
                        type="password"
                        name="支付密码"
                        label="支付密码"
                        placeholder=""
                        :rules="[{ required: true, message: '请填写密码' }]"
                />

                <van-field style="border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;"
                        v-model="loginFrom.passwordbool"
                        type="password"
                        name="确认密码"
                        label="确认密码"
                        placeholder=""
                        :rules="[{ required: true, message: '请在此输入密码' }]"
                />



                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit">提交</van-button>
                </div>
            </van-form>
        </div>

    </div>
</template>

<script>

    import { Col,Row,Icon,Image,Form,Field,Button,Cell,CellGroup,DatetimePicker,Popup,Toast,Uploader} from 'vant';
    import {getCodeTelephone} from "../../network/login/login";
    import {UpdataUserPay} from "../../network/mine/mine.js";
    import NavBar from "@/components/common/navbar/NavBar";

    export default {
        name: "setUserPay",
        components: {
            [Col.name]: Col,
            [Row.name]: Row,
            [Icon.name]: Icon,
            [Image.name]: Image,
            [Form.name ]: Form,
            [Field.name ]: Field,
            [Button.name ]: Button,
            [Cell.name ]: Cell,
            [CellGroup.name ]: CellGroup,
            [DatetimePicker.name ]: DatetimePicker,
            [Popup.name ]: Popup,
            [Uploader.name]:Uploader,
            NavBar: NavBar,
        },
        data(){
            return{
                loginFrom:{
                    id:"",
                    telephone:"",
                    authCode:"",
                    password:"",
                    passwordbool:"",
                },
                disabled:false,
                num:60,
                timer:"",

            }
        },
        methods:{
            //提交支付表达
            onSubmit(){
                if (this.loginFrom.authCode == ""){
                    Toast("输入验证码!")
                    return false;
                }

                if(this.loginFrom.password == "" ||
                   this.loginFrom.passwordbool ||
                   this.loginFrom.password != this.loginFrom.passwordbool){

                    const data = {
                        authCode: this.loginFrom.authCode,
                        telephone: this.loginFrom.telephone,
                        password: this.loginFrom.password,
                    }

                    UpdataUserPay(data).then(res => {
                        if(res.code == 200){
                            Toast("修改成功！");
                            if (this.$route.query.lastSource == 'noSubmitOrder'){
                                return this.$router.push("/order/personalOrders");
                            }
                            this.$router.push({path: '/mine'})
                        }
                    },err =>{
                        Toast('请输入正确的手机号码！')
                    })

                }else {
                    Toast('两次密码不正确 或者密码为空')
                }
            },
            goBack(){
                this.$router.back(-1);
            },
            getcode(){ //获取验证码
                if (this.loginFrom.telephone == ''){
                    Toast('请输入手机号码!')
                    return false;
                }
                if(this.loginFrom.telephone.length != 11){
                    Toast('请输入正确的手机号码!')
                    return false;
                }
                getCodeTelephone(this.loginFrom.telephone).then((res)=>{
                    //设置禁止按钮
                    this.disabled = true;
                    Toast('验证码发送成功')
                    this.disabledfun()
                })
            },
            disabledfun(){
                this.timer = setInterval(this.addnum, 1000);
            },
            addnum(){//设置计时器
                if (this.num == 0){
                    this.num = 60;
                    this.disabled = false;
                    clearInterval(this.timer);
                    return true;
                }
                this.num--;
            }

        }

    }
</script>



<style scoped>
    @import "~@/assets/css/index/style.css";
    @import "~@/assets/css/index/home.css";

    #setUserPay{
        background: #f8f6f7;
        /*height: 800px;*/
        width: 100%;
    }

    .van-nav-bar {
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, .5);
        background-color: #ffffff;
    }
    .brand-list-index {
        margin-top: 46px;
        height: 182px;
    }
    .brand-list-info {
        height: 124px;
        border-bottom: 1px solid #ccc;
    }

    .class-list-info-one {
        padding: 20px 10px;
    }

    .class-list-info-one .van-image {
        float: left;
    }

    .brand-list-text {
        display: inline-block;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 25px;
        color: #666666;
        font-size: 15px;
    }

    .brand-list-text-item {
        display: flex;
        flex-flow: column;
        height: 71px;
    }

</style>
